'use client'
import {
  ThemeButton_default
} from "./chunk-VYWHMVWT.mjs";
import {
  useFilterState
} from "./chunk-TOSXVIFC.mjs";
import {
  useGetOrganizerList
} from "./chunk-AI3DVZJL.mjs";
import {
  useGetEventsList
} from "./chunk-TW33R6V4.mjs";
import {
  useGetCategories
} from "./chunk-HKGNX5TB.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/filters/Filters.tsx
import { Fragment, useRef } from "react";
import { Divider, ResponsiveModal } from "@wbk/ui";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation as useTranslation6 } from "@wbk/config";
import { FilterIcon } from "@wbk/svg";

// src/components/filters/Price.tsx
import { useState } from "react";
import { Slider, Switch, Typography } from "@wbk/ui";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "@wbk/config";
import { CurrencyPriceLabel } from "@wbk/currency";
import { jsx, jsxs } from "react/jsx-runtime";
var PriceFilter = () => {
  var _a;
  const { watch, setValue } = useFormContext();
  const { t } = useTranslation("calendar_explore");
  const { data: sortedEvents } = useGetEventsList(
    {
      order: "price_DESC",
      limit: 1
    },
    { staleTime: Infinity }
  );
  const [fromState, toState] = watch(["minPrice", "maxPrice"]);
  const hightestPrice = ((_a = sortedEvents == null ? void 0 : sortedEvents.items[0]) == null ? void 0 : _a.price) || 0;
  const from = Number(fromState) || 0;
  const to = Number(toState);
  const safeTo = typeof toState === "undefined" ? hightestPrice : to;
  const [free, setFree] = useState(from === 0 && to === 0);
  return /* @__PURE__ */ jsxs("div", { className: "space-y-4", children: [
    /* @__PURE__ */ jsx(Typography, { variant: "label-L", children: t("calendar_explore:price") }),
    /* @__PURE__ */ jsxs("div", { className: "space-y-8", children: [
      /* @__PURE__ */ jsxs("div", { className: "space-y-4", children: [
        /* @__PURE__ */ jsx(
          Slider,
          {
            defaultValue: free ? [0, 0] : [from, safeTo],
            onPointerDown: () => {
              if (free) {
                setFree(false);
                setValue("minPrice", void 0);
                setValue("maxPrice", void 0);
              }
            },
            onValueCommit: ([from2, to2]) => {
              const reset = from2 === 0 && to2 === hightestPrice;
              const newFrom = reset ? void 0 : from2;
              const newTo = reset ? void 0 : to2;
              setValue("minPrice", newFrom == null ? void 0 : newFrom.toString());
              setValue("maxPrice", newTo == null ? void 0 : newTo.toString());
            },
            minStepsBetweenThumbs: 2,
            step: hightestPrice * 0.05,
            min: 0,
            max: hightestPrice,
            disabled: from === 0 && to === 0
          },
          `${hightestPrice}_${free}`
        ),
        /* @__PURE__ */ jsxs("div", { className: "text-text-secondary flex items-center gap-2", children: [
          /* @__PURE__ */ jsx(CurrencyPriceLabel, { originalPrice: from }),
          " ",
          " - ",
          /* @__PURE__ */ jsx(CurrencyPriceLabel, { originalPrice: to === 0 ? 0 : to || hightestPrice })
        ] })
      ] }),
      /* @__PURE__ */ jsx(
        Switch,
        {
          onChange: (checked) => {
            setFree(checked);
            setValue("minPrice", "0");
            setValue("maxPrice", checked ? "0" : hightestPrice == null ? void 0 : hightestPrice.toString());
          },
          size: "M",
          checked: free,
          groupClassName: "[&_div]:justify-between [&_div]:flex-row-reverse",
          label: /* @__PURE__ */ jsx(Typography, { variant: "label-L", children: t("calendar_explore:free_events_only") }),
          hideErrorSpace: true
        }
      )
    ] })
  ] });
};
var Price_default = PriceFilter;

// src/components/filters/Date.tsx
import { Controller, useFormContext as useFormContext2 } from "react-hook-form";
import { DayPicker, ToggleGroup, Typography as Typography2 } from "@wbk/ui";
import { formatDate } from "@wbk/utils";
import { AnimatePresence, motion } from "motion/react";
import { useRouter, useTranslation as useTranslation2 } from "@wbk/config";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var dateOptions = [
  {
    text: "today",
    value: "today",
    id: "today"
  },
  {
    text: "tomorrow",
    value: "tomorrow",
    id: "tomorrow"
  },
  {
    text: "thisweek",
    value: "thisweek",
    id: "thisweek"
  },
  {
    text: "thismonth",
    value: "thismonth",
    id: "thismonth"
  },
  {
    text: "custom_date",
    value: "custom",
    id: "custom"
  }
];
var DateFilter = () => {
  const { t } = useTranslation2("calendar_explore");
  const { control, setValue, watch } = useFormContext2();
  const { locale } = useRouter();
  const [from, to] = watch(["from", "to"]);
  return /* @__PURE__ */ jsx2(
    Controller,
    {
      control,
      name: "date",
      render: ({ field: { onChange, value } }) => {
        const isCustom = value === "custom";
        return /* @__PURE__ */ jsxs2("div", { className: "space-y-2", children: [
          /* @__PURE__ */ jsx2(Typography2, { variant: "label-L", children: t("calendar_explore:date") }),
          /* @__PURE__ */ jsx2(
            ToggleGroup,
            {
              showClose: true,
              type: "single",
              className: "border-category rounded-radius shadow-category flex-initial border-2",
              value,
              onChange: (newValue) => {
                if (newValue !== "custom") {
                  setValue("from", void 0);
                  setValue("to", void 0);
                }
                onChange(newValue);
              },
              options: dateOptions.map((option) => ({
                text: t(`calendar_explore:${option.text}`),
                value: option.value
              })),
              btnProps: { theme: "secondary", shape: "solid" },
              activeBtnProps: {
                theme: "secondary",
                className: "bg-body-light border-primary hover:bg-body-light hover:bg-secondary-400"
              }
            }
          ),
          /* @__PURE__ */ jsx2(AnimatePresence, { children: isCustom && /* @__PURE__ */ jsx2(
            motion.div,
            {
              initial: { height: 0 },
              animate: { height: isCustom ? "auto" : 0 },
              exit: { height: 0 },
              className: "overflow-hidden",
              children: /* @__PURE__ */ jsx2(
                DayPicker,
                {
                  className: "bg-body-level-1 w-full rounded-lg p-2",
                  lang: locale,
                  mode: "range",
                  fromDate: /* @__PURE__ */ new Date(),
                  defaultMonth: from,
                  selected: { from, to },
                  onSelect: (value2) => {
                    setValue("from", value2 == null ? void 0 : value2.from);
                    setValue("to", value2 == null ? void 0 : value2.to);
                  },
                  components: {
                    CaptionLabel: ({ displayMonth }) => {
                      return /* @__PURE__ */ jsx2(Typography2, { className: "px-4", children: formatDate(displayMonth, locale, { month: "long", year: "numeric" }) });
                    }
                  }
                }
              )
            }
          ) })
        ] });
      }
    }
  );
};
var Date_default = DateFilter;

// src/components/filters/Organizers.tsx
import { useFormContext as useFormContext3 } from "react-hook-form";
import { useRouter as useRouter2, useTranslation as useTranslation4 } from "@wbk/config";

// src/components/filters/CheckboxList.tsx
import { useState as useState2 } from "react";
import { Button, Checkbox, Typography as Typography3 } from "@wbk/ui";
import { motion as motion2 } from "motion/react";
import { useTranslation as useTranslation3 } from "@wbk/config";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var FilterCheckboxList = ({ title, list, onChange, loading, initialVisible = 5 }) => {
  const [showAll, setShowAll] = useState2(false);
  const { t } = useTranslation3("calendar_common");
  const maxVisible = Math.min((list == null ? void 0 : list.length) || 0, initialVisible);
  if (loading) {
    return /* @__PURE__ */ jsxs3("div", { className: "space-y-4", children: [
      /* @__PURE__ */ jsx3(Typography3, { as: "h2", variant: "body-L", children: title }),
      /* @__PURE__ */ jsx3("div", { className: "space-y-2 overflow-hidden px-0.5", children: [1, 2, 3].map((i) => /* @__PURE__ */ jsx3("div", { className: "bg-body-level-1 h-7 animate-pulse rounded-md" }, i)) })
    ] });
  }
  if (!(list == null ? void 0 : list.length)) {
    return null;
  }
  return /* @__PURE__ */ jsxs3("div", { className: "space-y-4", children: [
    /* @__PURE__ */ jsx3(Typography3, { as: "h2", variant: "body-L", children: title }),
    /* @__PURE__ */ jsx3(
      motion2.ul,
      {
        className: "space-y-4 overflow-hidden px-0.5",
        initial: false,
        animate: { height: showAll ? "auto" : maxVisible * 40 - 16 },
        transition: { duration: 0.3 },
        children: list.map((item) => /* @__PURE__ */ jsx3("li", { className: "flex justify-between", children: /* @__PURE__ */ jsx3(
          Checkbox,
          {
            checked: item.checked,
            name: item.value,
            onChange: () => {
              onChange(item.value);
            },
            label: /* @__PURE__ */ jsx3(Typography3, { className: "line-clamp-1", children: item.title })
          }
        ) }, item.value))
      }
    ),
    list.length > maxVisible && /* @__PURE__ */ jsx3(
      Button,
      {
        type: "button",
        shape: "text",
        className: "p-0.5",
        onClick: () => {
          setShowAll((prev) => !prev);
        },
        children: /* @__PURE__ */ jsx3(Typography3, { variant: "link-S", children: showAll ? t("calendar_common:read_less") : t("calendar_common:read_more") })
      }
    )
  ] });
};
var CheckboxList_default = FilterCheckboxList;

// src/components/filters/Organizers.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var Organizers = () => {
  const { locale } = useRouter2();
  const { t } = useTranslation4("calendar_explore");
  const { data, isLoading } = useGetOrganizerList({
    lang: locale
  });
  const { setValue, watch } = useFormContext3();
  const value = watch("organizer") || [];
  return /* @__PURE__ */ jsx4(
    CheckboxList_default,
    {
      title: t("calendar_explore:season_organizer"),
      loading: isLoading,
      list: data == null ? void 0 : data.items.map((org) => ({
        title: org.title,
        value: org.slug,
        checked: value.includes(org.slug)
      })),
      onChange: (slug) => {
        const newValue = value.includes(slug) ? value.filter((v) => v !== slug) : value.concat(slug);
        setValue("organizer", newValue);
      }
    }
  );
};
var Organizers_default = Organizers;

// src/components/filters/categories/Selector.tsx
import { useFormContext as useFormContext4 } from "react-hook-form";
import { useRouter as useRouter3, useTranslation as useTranslation5 } from "@wbk/config";
import { jsx as jsx5 } from "react/jsx-runtime";
var CategoryFilterSelector = () => {
  const { locale } = useRouter3();
  const { t } = useTranslation5("calendar_explore");
  const { data, isLoading } = useGetCategories({
    limit: 40,
    lang: locale,
    where: { parent_exists: false }
  });
  const { setValue, watch } = useFormContext4();
  const value = watch("category") || "";
  return /* @__PURE__ */ jsx5(
    CheckboxList_default,
    {
      title: t("calendar_explore:categories"),
      loading: isLoading,
      list: data == null ? void 0 : data.map((cat) => ({
        title: cat.title,
        value: cat.slug,
        checked: value === cat.slug
      })),
      onChange: (slug) => {
        setValue("category", slug);
      }
    }
  );
};
var Selector_default = CategoryFilterSelector;

// src/components/filters/Filters.tsx
import { jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var FILTERS = ["date", "price", "category", "organizer"];
var FILTERS_COMPONENTS = {
  date: /* @__PURE__ */ jsx6(Date_default, {}),
  price: /* @__PURE__ */ jsx6(Price_default, {}),
  category: /* @__PURE__ */ jsx6(Selector_default, {}),
  organizer: /* @__PURE__ */ jsx6(Organizers_default, {})
};
var FilterButton = ({ filters = FILTERS, showLabel = true }) => {
  const { t } = useTranslation6(["calendar_explore", "calendar_common"]);
  const { reset, total } = useFilterState();
  const modalRef = useRef(void 0);
  return /* @__PURE__ */ jsx6(
    ResponsiveModal,
    {
      ignoreHistory: true,
      ref: modalRef,
      position: "right",
      actionsStyle: "fixed",
      title: t("calendar_explore:filters"),
      cancel: {
        label: t("calendar_common:clear_all"),
        className: "w-full",
        theme: "primary",
        onClick: () => {
          var _a;
          (_a = modalRef.current) == null ? void 0 : _a.close();
          reset();
        }
      },
      action: {
        label: t("calendar_common:apply"),
        form: "filters-form",
        className: "w-full",
        theme: "primary"
      },
      render: ({ open }) => /* @__PURE__ */ jsxs4(
        ThemeButton_default,
        {
          type: "button",
          theme: "secondary",
          className: "rounded-radius shadow-category border-category relative overflow-visible border-2",
          onClick: open,
          children: [
            /* @__PURE__ */ jsx6(FilterIcon, { className: "h-4 w-4" }),
            showLabel && /* @__PURE__ */ jsx6("span", { children: t("calendar_explore:filters") }),
            total > 0 && /* @__PURE__ */ jsx6("span", { className: "bg-error text-error-contrast absolute -top-2 flex h-5 w-5 items-center justify-center rounded-full p-1 text-xs ltr:-right-2 rtl:-left-2", children: total })
          ]
        }
      ),
      body: ({ close }) => /* @__PURE__ */ jsx6(Body, { filters, onClose: close })
    }
  );
};
var Body = ({ filters, onClose }) => {
  const { state, setState } = useFilterState();
  const methods = useForm({
    defaultValues: state
  });
  const onSubmit = (data) => {
    setState(data);
    onClose();
  };
  return /* @__PURE__ */ jsx6(FormProvider, __spreadProps(__spreadValues({}, methods), { children: /* @__PURE__ */ jsx6("form", { id: "filters-form", className: "space-y-6", onSubmit: methods.handleSubmit(onSubmit), children: filters == null ? void 0 : filters.map((filter, i) => /* @__PURE__ */ jsxs4(Fragment, { children: [
    FILTERS_COMPONENTS[filter],
    i < filters.length - 1 && /* @__PURE__ */ jsx6(Divider, {})
  ] }, filter)) }) }));
};
var Filters_default = FilterButton;

export {
  Filters_default
};
//# sourceMappingURL=chunk-UDXU34ZZ.mjs.map